import {Injectable} from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {PARAM_TOKEN} from './navigators/navigators';
import {AvoirsPath} from '../../pages/avoirs/avoirs-path';

@Injectable({
  providedIn: 'root',
})
export class AvoirsNavService extends NavService {
  constructor(protected router: Router) {
    super(router);
  }

  edition_avoir = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.AVOIR,
    AvoirsPath.EDITION,
    PARAM_TOKEN,
    AvoirsPath.GENERAL,
  );
}
